import { getItem } from '../../utils/getItem';
import { ClientItemId } from 'owa-client-ids';
import { ComposeTarget, lazyLoadDraftToCompose } from 'owa-mail-compose-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { loadItem } from 'owa-mail-store-actions';
import popoutReadingPane from 'owa-popout-utils/lib/utils/popoutReadingPane';

export async function displayMessageForm(itemId: string) {
    let item = getItem(itemId);
    if (!item || !item.NormalizedBody) {
        const clientItemId: ClientItemId = {
            Id: itemId,
            mailboxInfo: getMailboxInfo(getSelectedTableView()),
        };
        item = await loadItem(clientItemId, 'LoadItemReadingPane');
    }

    if (item.IsDraft) {
        await openComposeItem(itemId);
    } else {
        if (isFeatureEnabled('rp-popouts')) {
            popoutReadingPane(itemId);
        }
    }
}

export async function openComposeItem(itemId: string) {
    if (isFeatureEnabled('rp-popouts')) {
        await lazyLoadDraftToCompose.importAndExecute(itemId, ComposeTarget.Popout);
    }
}
